var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvitesmaiden({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{stroke:#FFFFFF;stroke-width:4;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M518.4,270.3v-69.6c0-31.4-74-56-168.4-56c-94.4,0-168.4,24.6-168.4,56v69.6C127.2,286,97.2,308,97.2,332.4 c0,46.5,111,82.9,252.8,82.9c141.8,0,252.8-36.4,252.8-82.9C602.8,308,572.8,286,518.4,270.3L518.4,270.3z M350,151.9 c96.4,0,161.2,25.2,161.2,48.8c0,23.6-64.8,48.8-161.2,48.8c-96.4,0-161.2-25.2-161.2-48.8C188.8,177.1,253.6,151.9,350,151.9z  M188.8,268.2v-50.9c20.8,23.1,84.2,39.5,161.2,39.5c77,0,140.4-16.4,161.2-39.5v55.8c0,23.6-64.8,48.8-161.2,48.8 c-96.4,0-161.2-25.2-161.2-48.8V268.2z M350,408.1c-133.1,0-245.6-34.7-245.6-75.7c0-20.4,28-40.2,77.1-54.6v29.8 c0,31.4,74,56.1,168.4,56.1c94.4,0,168.4-24.6,168.4-56.1v-29.8c49.1,14.5,77.1,34.3,77.1,54.6C595.6,373.5,483.1,408.1,350,408.1z "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitesmaiden);
export default __webpack_public_path__ + "static/media/invites maiden.24e7fbf5ae9701295018ce8574c65fc1.svg";
export { ForwardRef as ReactComponent };